import { observable } from 'mobx';
import BaseLoginStore from './BaseLoginStore';
import RootStore from './RootStore';

export interface EmailLoginPasswords {
  password: string;
  confirmPassword: string;
  key: string;
}

export default class ResetPasswordStore extends BaseLoginStore {
  @observable accessor emailLoginPasswords: EmailLoginPasswords = { password: '', confirmPassword: '', key: '' };

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public async handleLogin() {
    this.emailLoginPasswords.key = this.routeStore.decodedParams['key'];
    await this.handleLoginTemplate('/email/change-password', this.emailLoginPasswords);
  }
}
